import { createApi } from '@reduxjs/toolkit/query/react';

import { TGetThreadsParams, TThread, TThreadsResponse } from '@/types/threads';

import { baseQueryWithReauth } from './utils';

export const threadsApi = createApi({
  reducerPath: 'threadsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getThreads: build.query<TThreadsResponse, TGetThreadsParams>({
      query: (params: TGetThreadsParams) => ({
        url: 'run-history/get-threads',
        method: 'POST',
        body: params,
      }),
    }),
    getThread: build.query<TThread, string>({
      query: (referenceId: string) => ({
        url: 'run-history/get-thread',
        method: 'GET',
        params: { referenceId },
      }),
    }),
  }),
});

export const { useGetThreadsQuery, useGetThreadQuery, useLazyGetThreadQuery } = threadsApi;
